import { orderStatusHeaderStyles } from "@insite/content-library/Widgets/OrderStatus/OrderStatusHeader";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

orderStatusHeaderStyles!.shareEntityButtonStyles!.button!.css = css`
    color: ${getColor("white")};
    &:not(:disabled):hover {
        color: ${getColor("white")};
    }
`;